module.exports = __webpack_public_path__ + "img/bgCircle.7eedf140.svg";